/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ServiceRequestProcessingCreate } from '../models/ServiceRequestProcessingCreate';
import type { ServiceRequestProcessingOut } from '../models/ServiceRequestProcessingOut';
import type { ServiceRequestProcessingUpdate } from '../models/ServiceRequestProcessingUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RequestTrackingService {
    /**
     * Create Status
     * @param requestBody
     * @returns ServiceRequestProcessingOut Successful Response
     * @throws ApiError
     */
    public static createStatusServiceRequestsStatusPost(
        requestBody: ServiceRequestProcessingCreate,
    ): CancelablePromise<ServiceRequestProcessingOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/service-requests/status/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Status History
     * @param requestId
     * @returns ServiceRequestProcessingOut Successful Response
     * @throws ApiError
     */
    public static listStatusHistoryServiceRequestsStatusByRequestRequestIdGet(
        requestId: number,
    ): CancelablePromise<Array<ServiceRequestProcessingOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/service-requests/status/by-request/{request_id}',
            path: {
                'request_id': requestId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Status Entry
     * @param entryId
     * @returns ServiceRequestProcessingOut Successful Response
     * @throws ApiError
     */
    public static getStatusEntryServiceRequestsStatusEntryIdGet(
        entryId: number,
    ): CancelablePromise<ServiceRequestProcessingOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/service-requests/status/{entry_id}',
            path: {
                'entry_id': entryId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Status Entry
     * @param entryId
     * @param requestBody
     * @returns ServiceRequestProcessingOut Successful Response
     * @throws ApiError
     */
    public static updateStatusEntryServiceRequestsStatusEntryIdPut(
        entryId: number,
        requestBody: ServiceRequestProcessingUpdate,
    ): CancelablePromise<ServiceRequestProcessingOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/service-requests/status/{entry_id}',
            path: {
                'entry_id': entryId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Status Entry
     * @param entryId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteStatusEntryServiceRequestsStatusEntryIdDelete(
        entryId: number,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/service-requests/status/{entry_id}',
            path: {
                'entry_id': entryId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
